(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function setHeaderHeights(section) {
    if (!section) return;
    var announce = section.querySelector('[data-hland-announce]');
    var header = section.querySelector('[data-hland-header]');
    var announceHeight = announce ? announce.offsetHeight : 0;
    var headerHeight = header ? header.offsetHeight : 0;
    var total = announceHeight + headerHeight;
    var megaTop = announceHeight + headerHeight;

    document.documentElement.style.setProperty('--hland-announcement-bar-height', announceHeight + 'px');
    document.documentElement.style.setProperty('--hland-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--hland-header-total-height', total + 'px');
    section.style.setProperty('--hland-mega-menu-top', megaTop + 'px');
  }

  function initScroll(section, header) {
    if (header.dataset.hlandScrollBound) return;
    if (!header.classList.contains('hland-header--transparent')) return;
    header.dataset.hlandScrollBound = '1';

    function onScroll() {
      header.classList.toggle('hland-header--solid', window.scrollY > 8);
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initHover(section, header) {
    if (!header.classList.contains('hland-header--transparent')) return;
    if (header.dataset.hlandHoverBound) return;
    header.dataset.hlandHoverBound = '1';

    section.addEventListener('mouseenter', function () {
      header.classList.add('hland-header--hovered');
    });

    section.addEventListener('mouseleave', function () {
      if (!header.classList.contains('hland-header--dropdown-open')) {
        header.classList.remove('hland-header--hovered');
      }
    });

    section.addEventListener('focusin', function () {
      header.classList.add('hland-header--hovered');
    });

    section.addEventListener('focusout', function (e) {
      if (!section.contains(e.relatedTarget) && !header.classList.contains('hland-header--dropdown-open')) {
        header.classList.remove('hland-header--hovered');
      }
    });
  }

  function initDesktopDropdowns(section, header) {
    if (section.dataset.hlandDesktopNavBound) return;
    section.dataset.hlandDesktopNavBound = '1';

    var parents = section.querySelectorAll('[data-hland-nav-desktop]');
    var closeTimer = null;

    function isDesktop() {
      return DESKTOP_MQ.matches;
    }

    function closeAll() {
      parents.forEach(function (item) {
        item.classList.remove('is-open');
        var toggle = item.querySelector('[data-hland-nav-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
      header.classList.remove('hland-header--dropdown-open');
      if (!section.matches(':hover') && window.scrollY <= 8) {
        header.classList.remove('hland-header--hovered');
      }
    }

    function openItem(item) {
      closeAll();
      item.classList.add('is-open');
      var toggle = item.querySelector('[data-hland-nav-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      header.classList.add('hland-header--dropdown-open');
      header.classList.add('hland-header--hovered');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 140);
    }

    parents.forEach(function (item) {
      var dropdown = item.querySelector('[data-hland-nav-dropdown]');
      if (!dropdown) return;

      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        openItem(item);
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        scheduleClose();
      });

      dropdown.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        openItem(item);
      });

      dropdown.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        scheduleClose();
      });

      item.addEventListener('focusin', function () {
        if (!isDesktop()) return;
        openItem(item);
      });
    });

    section.addEventListener('focusout', function (e) {
      if (!isDesktop()) return;
      if (!section.contains(e.relatedTarget)) closeAll();
    });

    DESKTOP_MQ.addEventListener('change', function () {
      closeAll();
    });
  }

  function initHeader(section) {
    var header = section.querySelector('[data-hland-header]');
    if (!header || header.dataset.hlandHeaderBound) return;
    header.dataset.hlandHeaderBound = '1';

    setHeaderHeights(section);
    initScroll(section, header);
    initHover(section, header);
    initDesktopDropdowns(section, header);

    var mobileToggle = section.querySelector('[data-hland-mobile-nav-toggle]');
    var mobileDrawer = section.querySelector('[data-hland-mobile-drawer]');
    var mqMobile = window.matchMedia('(max-width: 989px)');

    function isMobile() {
      return mqMobile.matches;
    }

    function closeMobileSubmenus() {
      section.querySelectorAll('[data-hland-mobile-submenu-toggle][aria-expanded="true"]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        var panelId = toggle.getAttribute('aria-controls');
        if (panelId) {
          var panel = section.querySelector('#' + panelId);
          if (panel) panel.setAttribute('hidden', '');
        }
      });
    }

    function openMobileDrawer() {
      if (!mobileDrawer || !mobileToggle) return;
      mobileDrawer.removeAttribute('hidden');
      mobileDrawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        mobileDrawer.classList.add('is-open');
      });
      mobileToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('hland-mobile-nav-open');
    }

    function closeMobileDrawer() {
      if (!mobileDrawer || !mobileToggle) return;
      mobileDrawer.classList.remove('is-open');
      mobileDrawer.setAttribute('aria-hidden', 'true');
      mobileToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hland-mobile-nav-open');
      closeMobileSubmenus();
      window.setTimeout(function () {
        if (!mobileDrawer.classList.contains('is-open')) {
          mobileDrawer.setAttribute('hidden', '');
        }
      }, 460);
    }

    section.querySelectorAll('[data-hland-mobile-submenu-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (!isMobile()) return;
        var panelId = toggle.getAttribute('aria-controls');
        if (!panelId) return;
        var panel = section.querySelector('#' + panelId);
        if (!panel) return;
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) panel.setAttribute('hidden', '');
        else panel.removeAttribute('hidden');
      });
    });

    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener('click', function () {
        if (mobileDrawer.classList.contains('is-open')) closeMobileDrawer();
        else openMobileDrawer();
      });

      mobileDrawer.querySelectorAll('[data-hland-mobile-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeMobileDrawer);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('is-open')) {
        closeMobileDrawer();
      }
    });

    mqMobile.addEventListener('change', function () {
      if (!mqMobile.matches) closeMobileDrawer();
    });

    window.addEventListener('resize', function () {
      setHeaderHeights(section);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        setHeaderHeights(section);
      });
      var announce = section.querySelector('[data-hland-announce]');
      if (announce) ro.observe(announce);
      ro.observe(header);
    }
  }

  function boot() {
    document.documentElement.classList.add('js');
    document.querySelectorAll('[data-hland-header-section]').forEach(initHeader);
  }

  boot();

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-hland-header-section]') || e.target.closest('[data-hland-header-section]');
    if (section) initHeader(section);
  });
})();
